/**
 * autocreated commitinfo by @push.rocks/commitinfo
 */
export const commitinfo = {
  name: 'lossless.com',
  version: '1.2.1',
  description: 'website for lossless.com'
}
